exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-summary[data-v-18c4d762]{padding-top:20px;border-top:2px solid #d9d9d9}", ""]);

// exports
